// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APP_ENV: 'dev',
  API_URL: window.location.protocol + '//' + window.location.host.replace(/admin|subscriber|operator|platform|organization/, 'admin-api') + '/api/',
  STATIC_URL: window.location.protocol + '//' + window.location.host.replace(/admin|subscriber|operator|platform|organization/, 'admin-api') + '/',
  S3_URL: 'https://item-bucket-develop.s3.eu-central-1.amazonaws.com/',
  SUPER_URL: 'admin',
  SUB_URL: 'operator',
  ORGANIZATION_URL: 'platform',
  DEV_URL: '',
  DOCUMENTATION_FILE: "documentation.json"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
